import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as Image from 'types/Media/Image';

interface IProps {
	image: Image.Type | null;
}

const Picture = (props: IProps) => {
	if (props.image) {
		return (
			<div className="card-picture">
				<img alt="thumbnail" src={props.image.url} />
			</div>
		);
	}
	return (
		<div className="card-picture-placeholder d-flex justify-content-center align-items-center">
			<FontAwesomeIcon size="3x" icon={faCamera} />
		</div>
	);
};

export default Picture;
